import { Component, ElementRef, OnInit, ViewEncapsulation } from '@angular/core';
import * as d3 from 'd3';

@Component({
  selector: 'app-donut-v4',
  templateUrl: './donut-v4.component.html',
  styleUrls: ['./donut-v4.component.scss']
})
export class DonutV4Component implements OnInit {

  private width: number =  800;
  private height: number = 400;
  private radius: number = null;
  private data: number[] = [1, 2, 3, 4];
  private color: any;
  private pieGen: any;
  private pieData: any;
  private arcGen: any;

  private labelArcGen: any;

  element: ElementRef;
  constructor( e: ElementRef) {
    this.element = e;
    this.radius = Math.min(this.width, this.height) / 2;
  }

  ngOnInit() {
    this.generatePieChart();
  }

  generatePieChart() {

    this.color = d3.scaleOrdinal().range(['#ffeeaa', '#ff0000', '#00ff00', '#0000ff', '#000000']);

    this.pieGen = d3.pie()
      .sort(null)
      .value((this.GetData));

    this.pieData = this.pieGen(this.data);


    this.arcGen = d3.arc()
      .outerRadius(this.radius - 10)
      .innerRadius(this.radius- 50);

    this.labelArcGen = d3.arc()
      .outerRadius(this.radius - 40)
      .innerRadius(this.radius - 40);

    // CREATE THE SVG.
    const svg = d3.select(this.element.nativeElement)
      .append('svg')
      .attr('width', this.width)
      .attr('height', this.height)
      .append('g')
      .attr('transform', 'translate(' + this.width / 2 + ',' + this.height / 2 + ')');

    // ADD THE ARCS.
    const g = svg.selectAll('.donut')
      .data(this.pieData)
      .enter()
      .append('g')
      .attr('class', 'donut');

      // Add the fill to those.
      g.append('path').attr('d', this.arcGen)
      .style('fill', (d: any, i: any) => this.color(i) )
      .style('stroke','black')
      .style('stroke-width','2px');

      g.append('text')
      .attr('transform', (d: any) => 'translate(' + this.labelArcGen.centroid(d) + ')')
      .attr('dy', '.35em')
      .text((d: any) => d.value);      
  }

  GetData(d): number  {
      return d;
  }
}
